export default async function retryApi(
  fnFactory,
  retries = 3,
  signal
) {
  const baseDelay = 200; // ms
  let attempt = 0;

  while (true) {
    attempt++;
    // If signal already aborted, short-circuit

    if (signal?.aborted) {
      return { err: true, data: null, message: "aborted", attempts: attempt };
    }

    try {
      const res = await fnFactory(signal);
      // If the function itself returns an error object, decide whether to retry:
      if (!res.error) return { ...res, attempts: attempt };
      // For API-defined errors (res.err === true) we can still retry depending on attempt
      if (attempt >= retries) return { ...res, attempts: attempt };
      // else fallthrough to retry
    } catch (e) {
      // Network or thrown error (shouldn't happen if fnFactory wraps), but handle it.
      if (attempt >= retries) {
        return { err: true, data: null, message: e?.message ?? String(e), attempts: attempt };
      }
    }

    // Wait with exponential backoff + small jitter
    const jitter = Math.random() * 100;
    const delay = baseDelay * Math.pow(2, attempt - 1) + jitter;
    await new Promise((r) => {
      const t = setTimeout(r, delay);
      // if aborted during delay, resolve early
      if (signal) {
        const onAbort = () => {
          clearTimeout(t);
          signal.removeEventListener("abort", onAbort);
          r(undefined);
        };
        signal.addEventListener("abort", onAbort, { once: true });
      }
    });

    // if signal aborted while waiting, break and return aborted
    if (signal?.aborted) return { err: true, data: null, message: "aborted", attempts: attempt };
  }
}

function lastValue(arr) {
  return arr && arr.length ? arr[arr.length - 1].value : null;
}
function sma(arr, period = 7) {
  if (!arr || arr.length < period) return null;
  let sum = 0;
  for (let i = arr.length - period; i < arr.length; i++) sum += arr[i].value;
  return sum / period;
}